import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotBoard from "./components/HotBoard";
import FeedSection from "./components/FeedSection";
import DeepTimeline from "./components/DeepTimeline";
import WeeklyRoundup from "./components/WeeklyRoundup";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import Footer from "./components/Footer";

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <button
      type="button"
      aria-label="回到顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-40 grid h-11 w-11 place-items-center rounded-full bg-primary-500 text-background-50 shadow-none transition-transform hover:-translate-y-1 hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}

export default function Home() {
  const [category, setCategory] = useState("全部");
  const [keyword, setKeyword] = useState("");

  const handleSearch = (kw: string) => {
    setKeyword(kw);
    setCategory("全部");
    setTimeout(() => {
      document.getElementById("feed")?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 60);
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero onSearch={handleSearch} />
        <HotBoard />
        <FeedSection
          category={category}
          keyword={keyword}
          onCategory={setCategory}
          onKeyword={(k) => {
            setKeyword(k);
            setTimeout(() => {
              document.getElementById("feed")?.scrollIntoView({ behavior: "smooth", block: "start" });
            }, 60);
          }}
        />
        <DeepTimeline />
        <WeeklyRoundup />
        <FaqSection />
        <AboutSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}